import * as Sentry from '@sentry/react';

const PII_PATTERNS = /email|phone|name|bio|city|country|address|avatar|slack|linkedin|twitter|github/i;

function scrubObject(obj: Record<string, unknown>): Record<string, unknown> {
  const cleaned: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (PII_PATTERNS.test(key)) {
      cleaned[key] = '[Filtered]';
    } else if (typeof value === 'string' && /@/.test(value)) {
      cleaned[key] = '[Filtered]';
    } else {
      cleaned[key] = value;
    }
  }
  return cleaned;
}

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    enabled: !!dsn,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      if (event.extra) {
        event.extra = scrubObject(event.extra as Record<string, unknown>);
      }
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(bc => {
          if (bc.data) {
            bc.data = scrubObject(bc.data as Record<string, unknown>);
          }
          return bc;
        });
      }
      if (event.user) {
        const { id } = event.user;
        event.user = { id };
      }
      return event;
    },
  });
}
